import { Mapper } from '@shared/helpers/mapper';
import {
  SecurityTypeTaxResultItemTypeResponse,
  TaxResultItemTypeNestedObjectResponse,
} from 'src/app/web-api-client';
import {
  SecurityTypeResult,
  TaxResultItemTypeResult,
} from '../../models/security-type-result';

export function mapSecurityTypeResult(
  securityTypeTaxResultItemTypeResponse: SecurityTypeTaxResultItemTypeResponse[]
): SecurityTypeResult[] {
  return Mapper.mapByList(
    securityTypeTaxResultItemTypeResponse,
    SecurityTypeResult,
    [
      {
        securityTypeId: (
          source: SecurityTypeTaxResultItemTypeResponse
        ): number => source.securityTypeId ?? 0,
        name: (source: SecurityTypeTaxResultItemTypeResponse): string =>
          source.name ?? '',
        taxResultItemTypeResults: (
          source: SecurityTypeTaxResultItemTypeResponse
        ): TaxResultItemTypeResult[] =>
          Mapper.mapByList(
            source.taxResultItemTypes ?? [],
            TaxResultItemTypeResult,
            [
              {
                taxResultItemTypeId: (
                  source: TaxResultItemTypeNestedObjectResponse
                ): number => source.taxResultItemTypeId ?? 0,
                name: (source: TaxResultItemTypeNestedObjectResponse): string =>
                  source.name ?? '',
              },
            ]
          ),
      },
    ]
  );
}
